import { render, staticRenderFns } from "./ActiveSubstanceInfo.vue?vue&type=template&id=06b1b7da&scoped=true&"
import script from "./ActiveSubstanceInfo.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1b7da",
  null
  
)

export default component.exports